var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.query && Number.isInteger(_vm.query.offset) ? 'router-link' : 'span',{tag:"router-link",attrs:{"to":{
    name: 'details-signalement-filtre',
    params: { slug: _vm.slug },
    query: _vm.query,
  }}},[_vm._v(" "+_vm._s(_vm.properties.title || _vm.featureId)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }